import { Box, Grid, Stack, styled } from "@mui/material";
import React from "react";
import TipsAndUpdatesOutlinedIcon from "@mui/icons-material/TipsAndUpdatesOutlined";
import { Typography } from "core";
import { useTranslation } from "react-i18next";
import { CONTENT_SUGGESTION_POINTS } from "config/app.config";
//---------------------------------------------------------

const StyledSubmitIdeaCard = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.primary.lighter,
  padding: "1rem",
}));

const StyledPointsText = styled(Typography)(({ theme }) => ({
  fontSize: "22px",
  color: theme.palette.secondary.dark,
  fontWeight: "bolder",
  textAlign: "center",
}));

const StyledGrid = styled(Grid)(({ theme }) => ({
  [theme.breakpoints.down("sm")]: {
    maxWidth: "100%",
    flexBasis: "100%",
  },
}));
//---------------------------------------------------------

export default function SubmitIdea() {
  const { t: home } = useTranslation("home")

  return (
    <Grid
      container
      spacing={3}
      justifyContent="center"
      alignItems="center"
      direction="row"
    >
      <StyledGrid item xs={6}>
        <StyledSubmitIdeaCard
          direction="row"
          alignItems="center"
          justifyContent="space-evenly"
        >
          <TipsAndUpdatesOutlinedIcon
            sx={{
              color: (theme) => theme.palette.background.paper,
              height: 120,
              width: 120,
              opacity: "1",
            }}
          />
          <Stack justifyContent="center">
            <StyledPointsText>{home('your_idea_is_worth_100_coins', { points: CONTENT_SUGGESTION_POINTS })}</StyledPointsText>
            <Box
              sx={{
                maxWidth: "300px",
                margin: "auto",
                textAlign: "center",
              }}
            >
              <Typography size="small" paddingBottom="1rem" fontWeight="bolder">
                {home('submit_a_post_to_the_admin_and_you_could_win_up_to_100_coins', { points: CONTENT_SUGGESTION_POINTS })}
              </Typography>
            </Box>
          </Stack>
        </StyledSubmitIdeaCard>
      </StyledGrid>
    </Grid>
  );
}
